import React from 'react';
import { IconPropsOnIconWrapper } from '../Icon';
import ChevronDown from './ChevronDown';

const ChevronUp = (props: IconPropsOnIconWrapper): JSX.Element => (
  <ChevronDown {...props} style={{ transform: 'rotate(180deg)' }} />
);

export default ChevronUp;
